import "./src/App.css";

import { CircleCommonProvider } from "./src/providers/CircleCommonProvider";
import { CommunityCommonProvider, useCommunityCommonContext } from "./src/providers/CommunityCommonProvider";

import SettingConfigFirebaseContainer from "./src/containers/settingConfigFirebase";

import ModuleMessageTemplate from "./src/containers/messageTemplate";
import MessageTemplateListContainer from "./src/containers/messageTemplate/list";
import MessageTemplateEditContainer from "./src/containers/messageTemplate/edit";

import ModuleMessageTemplateCase from "./src/containers/messageTemplateCase";
import MessageTemplateCaseListContainer from "./src/containers/messageTemplateCase/list";
import MessageTemplateCaseEditContainer from "./src/containers/messageTemplateCase/edit";

import ModulePost from "./src/containers/post";
import PostListContainer from "./src/containers/post/list";
import PostEditContainer from "./src/containers/post/edit";

import ModuleTag from "./src/containers/tag";
import TagListContainer from "./src/containers/tag/list";
import TagEditContainer from "./src/containers/tag/edit";

import ModuleCategory from "./src/containers/category";
import CategoryListContainer from "./src/containers/category/list";
import CategoryEditContainer from "./src/containers/category/edit";

import ModuleTopic from "./src/containers/topic";
import TopicListContainer from "./src/containers/topic/list";
import TopicEditContainer from "./src/containers/topic/edit";

import ModuleNotification from "./src/containers/notification";
import NotificationListContainer from "./src/containers/notification/list";
import NotificationEditContainer from "./src/containers/notification/edit";

import ModuleCommunity from "./src/containers/community";
import CommunityListContainer from "./src/containers/community/list";
import CommunityEditContainer from "./src/containers/community/edit";

import ChannelListContainer from "./src/containers/channel";
import ChannelEditContainer from "./src/containers/channel/edit";

import CommentContainer from "./src/components/CommentContainer";
import BellNotification from "./src/components/BellNotification";

import CommunityMember from "./src/components/CommunityMember";
import CommunityPostFollow from "./src/components/CommunityPostFollow";
import CommunityChannelComponent from "./src/components/CommunityChannel";
import CommunityCommonLayout from "./src/components/CommunityCommonLayout";

import DialogInviteMember from "./src/components/CommunityMember/dialogInviteMember";

import { convertIRecordChannelToItemMenu } from "./src/components/Channel/convertData";


export {
    // *** Providers ***//
    CircleCommonProvider,
    CommunityCommonProvider,

    // *** Containers ***//
    ModuleMessageTemplate,
    MessageTemplateListContainer,
    MessageTemplateEditContainer,

    ModuleMessageTemplateCase,
    MessageTemplateCaseListContainer,
    MessageTemplateCaseEditContainer,

    ModulePost,
    PostListContainer,
    PostEditContainer,

    ModuleTag,
    TagListContainer,
    TagEditContainer,

    ModuleCategory,
    CategoryListContainer,
    CategoryEditContainer,

    ModuleTopic,
    TopicListContainer,
    TopicEditContainer,

    ModuleCommunity,
    CommunityListContainer,
    CommunityEditContainer,

    ModuleNotification,
    NotificationListContainer,
    NotificationEditContainer,

    ChannelListContainer,
    ChannelEditContainer,

    SettingConfigFirebaseContainer,

    // *** Hooks ***//
    convertIRecordChannelToItemMenu,
    // *** Context ***//
    useCommunityCommonContext,
    // *** Components ***//
    BellNotification,
    // Channel
    CommunityCommonLayout,
    CommunityChannelComponent,
    // end Channel
    CommunityMember,
    DialogInviteMember,
    CommunityPostFollow,
    // Comment Container
    CommentContainer,
};
